import React, { useState } from 'react';
import { Card, Col, Form, Row, Modal } from 'react-bootstrap';
import HcpTable from './HcpTable.js';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb.js';
import paths from 'routes/paths.js';
import IconButton from 'components/common/IconButton';
import AddEditHcpForm from './AddEditHcpForm.js';

const ViewHcp = () => {
    const [statusFilter, setStatusFilter] = useState('active');
    const [showModal, setShowModal] = useState(false);
    const [selectedHcp, setSelectedHcp] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'View-HCP', href: paths.viewHcp, isActive: true }
    ];

    const handleOpenAddModal = () => {
        setSelectedHcp(null);
        setShowModal(true);
    };

    const handleEditHcp = (hcp) => {
        setSelectedHcp(hcp);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedHcp(null);
    };

    const handleFormSuccess = () => {
        handleCloseModal();
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Row className="g-3">
                <Col lg={12}>
                    <Card className="mt-3">
                        <Card.Header className="py-3 border-bottom">
                            <h5 className="mb-0">HCP Directory</h5>
                        </Card.Header>

                        <Card.Body>
                            <HcpTable 
                                statusFilter={statusFilter}
                                setStatusFilter={setStatusFilter}
                                onAddHcp={handleOpenAddModal}
                                onEditHcp={handleEditHcp} 
                                refreshTrigger={refreshTrigger}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton className="bg-body-tertiary">
                    <Modal.Title as="h5">
                        {selectedHcp ? 'Edit HCP' : 'Add HCP'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <AddEditHcpForm
                        editData={selectedHcp}
                        onSuccess={handleFormSuccess}
                        onHide={handleCloseModal}
                        isModal={true}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ViewHcp;
